import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { HooksWireup } from '@frontend/sports/common/core/utils/hooks';
import { CdsPushStoreService } from '@frontend/sports/content-distribution/feature';

import { BaseDayOfRaceComponent } from '../../tournaments/base-day-of-race.component';

@HooksWireup()
@Component({
    selector: 'ms-greyhounds-today',
    templateUrl: 'greyhounds-today.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GreyhoundsDayOfRaceComponent extends BaseDayOfRaceComponent {
    readonly day: DayOfRaceDate;
    readonly sport: SportConstant = SportConstant.Greyhounds;
    errorMessage: string;

    constructor(
        public sitecore: Sitecore,
        route: ActivatedRoute,
        protected override changeDetector: ChangeDetectorRef,
        pushService: CdsPushStoreService,
    ) {
        super(route, changeDetector, pushService);
        this.day = route.snapshot.data.dayOfRace as DayOfRaceDate;
        this.errorMessage =
            this.day === DayOfRaceDate.Today ? sitecore.horseRacing.tournaments.ErrNoTodayRaces : sitecore.horseRacing.tournaments.ErrNoRaces;
    }
}
